
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"13","fill":"#9E0000","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.818.701a.3.3 0 00-.3-.3h-.077a.3.3 0 00-.3.3V2.01A1.731 1.731 0 003.75 3.706c0 .3.083.578.217.823L2.965 6.264H1.377v-.477a.3.3 0 00-.3-.3H1a.3.3 0 00-.3.3v1.607a.3.3 0 00.3.3h.077a.3.3 0 00.3-.3v-.477h1.211L.865 9.9l.104.865-.658 1.14a.3.3 0 00.11.41l.066.038a.3.3 0 00.41-.11l.653-1.13.814-.347 3.079-5.334c.012 0 .024.004.037.004a.08.08 0 00.008 0l.006-.001.005-.001.017-.002.92 1.594h.003l.879 1.53h.001l1.277 2.21.852.364.643 1.113a.3.3 0 00.41.11l.066-.039a.3.3 0 00.11-.41l-.682-1.18.1-.824-1.013-1.748-.716-1.236H9.72v.477a.3.3 0 00.3.3h.077a.3.3 0 00.3-.3V5.787a.3.3 0 00-.3-.3h-.077a.3.3 0 00-.3.3v.477H7.99c-.334-.577-.667-1.155-.997-1.735a1.71 1.71 0 00.217-.823c0-.84-.598-1.54-1.392-1.697V.7zM5.48 3.13a.577.577 0 100 1.154.577.577 0 000-1.154z","fill":"#fff"}})])
          )
        }
      }
    